import { variablePattern, wildCardPattern } from '../constants';
export var getMappingRegex = function (mapping) {
    var mappingWithWildCards = mapping.replace(new RegExp(variablePattern, 'g'), wildCardPattern);
    return RegExp("^".concat(mappingWithWildCards, "$"));
};
//# sourceMappingURL=get-mapping-regex.js.map